import router from '@/router'

const identity = window.localStorage.getItem("subjectType")
const fn = () => {}

window.PC = window.PC || {}

window.PC.$Rangers = window.collectEvent || fn

window.PC.$RangersEvent = function(name, params, fn) {
    if (!name) return
    window.PC.$Rangers(name, params)
    if (fn && typeof fn === 'function') {
        setTimeout(() => {
            fn()
        }, 250);
    }
}

// 获取dataFinder token
window.PC.$RangersEvent('getToken', (token) => {
    window.PC.$RangersToken = token
})

// dataFinder config 配置
window.PC.$RangersConfigInit = function (state, status = 'init') {
    let store = {}
    if (state.user) {
        store = Object.assign(store, state.user, state.app || {})
    } else {
        store = state
    }
    const info = store.info
    const getLoginStatus = () => {
        let status = '1'

        if (info && info.exhibitionUserCompleteState) {
            let infoStatus = info.exhibitionUserCompleteState
            if (infoStatus.completeExhibitionRegistration) {
                status = '5'
            } else if (!infoStatus.completeVisitor) {
                status = '2'
            } else if (!infoStatus.completeVisitorRegister) {
                status = '3'
            } else if (!infoStatus.completeQuestionnaire) {
                status = '4'
            }
        }
        return status
    }

    let params = {}
    if (status === 'init') {
        // 初始化
        params = {
            loginSatus: getLoginStatus(),
            App_id: store.appId,
            exhibition_id: store.exhibitionId,
            login_role: store.subjectType === 'ACTOR' ? 'exhibitors' : 'visitor',
            client: 'PC',
            project_id: '',
            role_id: '',
            useraccount_id: '',
            exhibitors_id: '',
            exhibitors_name: ''
        }
    } else if (status === 'clear') {
        // 登录退出
        params = {
            loginSatus: getLoginStatus(),
            project_id: '',
            role_id: '',
            useraccount_id: '',
            exhibitors_id: '',
            exhibitors_name: '',
            user_unique_id: window.PC.$RangersToken?.web_id || '',
            login_role: 'visitor'
        }
    } else if (status === 'change') {
        // 用户当前的状态
        params.loginSatus = getLoginStatus()
    } else if (status === 'changeIdentity') {
        // 身份切换
        params.login_role = store.subjectType === 'ACTOR' ? 'exhibitors' : 'visitor'
    }
    
    if (info) {
        if (info.projectId) {
            params.project_id = info.projectId
        }
        if (info.subjectId) {
            params.role_id = info.subjectId
        }
        if (info.exhibitorEmployee) {
            params.exhibitors_id = info.exhibitorEmployee.exhibitor.id
            params.exhibitors_name = info.exhibitorEmployee.exhibitor.name
        }
        if (info.userAccountId) {
            params.useraccount_id = info.userAccountId
            params.user_unique_id = info.userAccountId
        }
    }

    console.log(params)
    window.PC.$RangersEvent('config', params)
}

// 顶部导航
window.PC.$RangersEventNav = function(name) {
    let eventType = ''
    switch(name) {
        case 'actor':
            eventType = 'Hometop_navigation_findExhibitor_Click'
            break
        case 'product':
            eventType = 'Hometop_navigation_findExhibits_Click'
            break
        case 'map':
            eventType = 'Hometop_navigation_3DPavilion_Click'
            break
        case 'find-opportunity':
            eventType = 'Hometop_navigation_business_Click'
            break
        case 'live':
            eventType = 'Hometop_navigation_live_Click'
            break
        case 'aboutus':
            eventType = 'Hometop_navigation_aboutUs_Click'
            break
        case 'search':
            eventType = 'Hometop_navigation_search_Click'
            break
        case 'signUp':
            eventType = 'Hometop_navigation_signUp_Click'
            break
        case 'workbench':
            eventType = 'Hometop_navigation_workbench_Click'
            break
        case 'VR':
            eventType = 'Hometop_navigation_VR_Click'
            break
        case 'sand-table':
            eventType = 'Hometop_navigation_sandtable_Click'
            break
        case 'person':
            eventType = 'Hometop_navigation_findPerson_Click'
            break
    }
    window.PC.$RangersEvent(eventType)
}

// 搜索，筛选，浏览，排序（列表--找展商，找展品，找客商, 搜索列表）
window.PC.$RangersEventList = function(type, value, userType) {
    let { route } = router.resolve({})
    let source = route.name
    let identity = route.params.type || userType
    let eventType = ''
    let params
    
    switch(type) {
        case 'view':
            if (identity === 'product') {
                eventType = 'exhibitsProfile_view'
                params = {source}
            } else if (identity === 'actor') {
                eventType = 'exhibitorsProfile_view'
                params = {source}
            }
            break
        case 'keyword':
            if (identity === 'product') {
                eventType = 'exhibitsList_searchBtn_click'
                params = {
                    keywords: value,
                    source
                }
            } else if (identity === 'actor') {
                eventType = 'exhibitorsList_searchBtn_click'
                params = {
                    keywords: value,
                    source
                }
            }
            break
        case 'find':
            if (identity === 'product') {
                eventType = 'exhibitsList_filterBtn_click'
                params = {
                    answer_id: value,
                    source
                }
            } else if (identity === 'actor') {
                eventType = 'exhibitorsList_filterBtn_click'
                params = {
                    answer_id: value,
                    source
                }
            }
            break
        case 'sort':
            if (value === 'EXHIBITOR_UNIQUE_VISITOR') {
                eventType = 'exhibitorsList_attentionBtn_click'
            } else if (value === 'PRODUCT_PAGE_VIEW') {
                eventType = 'exhibitsList_attentionBtn_click'
            } else if (value === 'EXHIBITOR_ADVERTS_VIDEO') {
                eventType = 'exhibitorsList_videoBtn_click'
            } else if (value === 'EXHIBITOR_INITIAL') {
                eventType = 'exhibitorsList_A-ZBtn_click'
            } 
            // else if (value === 'PRODUCT_INITIAL') {

            // } else if (value === 'PRODUCT_VIDEO_URL') {

            // } 
            break
    }

    window.PC.$RangersEvent(eventType, params)
}

// 详情页面（展商，展品，客商，直播） 埋点
window.PC.$RangersEventDetail = function(id, data, type, moduleName) {
    let { route } = router.resolve({})
    let name = route.name
    let source = name
    let eventType = ''
    let params

    switch(type) {
        case 'actor':
            // 列表页面
            if (name === 'findList' || name === 'searchList') {
                eventType = 'exhibitorsProfile_click'
                params = {
                    exhibitor_id: id,
                    source
                }
            }
            // 首页
            if (name === 'Home') {
                // 视频播放
                if (moduleName === 'video') {
                    eventType = 'homeCarousel_video_enter_Click'
                    params = {
                        video_id: data.index,
                        exhibitor_id: id,
                        source
                    }
                }
                // 推荐展商
                if (moduleName === 'featured') {
                    eventType = 'homeFeatured_Exhibitor_details_click'
                    params = {
                        exhibitor_id: id,
                        source
                    }
                }
            }
            // 展品详情
            if (name === 'findExhibitDetail') {
                eventType = 'exhibitdetails_exhibitordetailbutton_click'
                params = {
                    exhibitor_id: id,
                    exhibit_id: data.id,
                    source
                }
            }
            // 客商商脉圈列表
            if (name === 'findOpportunity') {
                eventType = 'businesscirclelist_headportrait_click'
                params = {
                    exhibitor_id: id,
                    businessCircle_id: data.commercialDistrictId,
                    source
                }
            }
            // 直播列表
            if (name === 'liveList') {
                eventType = 'livebroadcastdetails_click'
                params = {
                    exhibitor_id: id,
                    live_id: data.id,
                    live_state: data.liveState,
                    source
                }
            }
            // 直播详情
            if (name === 'liveDetail') {
                eventType = 'livebroadcastdeliveDetail_exhibitor_details_clicktails_click'
                params = {
                    exhibitor_id: id,
                    live_id: data.id,
                    live_state: data.liveState,
                    source
                }
            }
            // 工作台浏览记录
            if (name === 'footprintList') {
                eventType = 'Browsinghistory_Exhibitordetails_click'
                params = {
                    exhibitor_id: id,
                    source
                }
            }
            // 工作台收藏记录
            if (name === 'CollectionList') {
                eventType = 'Collectionrecordpage_Exhibitordetails_click'
                params = {
                    exhibitor_id: id,
                    source
                }
            }
            // 工作台右侧广告位
            if (moduleName === 'advertisement_workbench_right') {
                eventType = 'workbenchpage_Advertisingspace_click'
                params = {
                    exhibitor_id: id,
                    module_name: moduleName,
                    source
                }
            }
            // 工作台邀约管理
            if (name === 'invite') {
                eventType = 'Invitationpagepage_Exhibitordetails_click'
                params = {
                    exhibitor_id: id,
                    source
                }
            }
            // 在邮件模板中点击进来的展品预览
            if (name === 'findExhibitorDetail') {
                eventType = 'exhibitordetails_view'
                params = {
                    exhibitor_id: id,
                    source
                }
                if (data.userAccountId) {
                    params.external_source = 'actorInvite' 
                }
            }
            break
        case 'product':
            // 列表页面
            if (name === 'findList' || name === 'searchList') {
                eventType = 'exhibitsProfile_click'
                params = {
                    exhibitor_id: data.exhibitorId,
                    exhibit_id: id,
                    source
                }
            }
            // 首页
            if (name === 'Home') {
                // 你可能喜欢
                if (moduleName === 'like') {
                    eventType = 'homelike_Exhibit_details_click'
                    params = {
                        exhibitor_id: data.exhibitorId,
                        exhibit_id: id,
                        source
                    }
                }
                // 热门展商
                if (moduleName === 'hotExhibits') {
                    eventType = 'homehotpictures_Exhibits_click'
                    params = {
                        exhibitor_id: data.exhibitorId,
                        exhibit_id: id,
                        source
                    }
                }
            }
            // 展商详情页面
            if (name === 'findExhibitorDetail') {
                eventType = 'exhibitordetails_exhibit_click'
                params = {
                    exhibitor_id: data.exhibitorId,
                    exhibit_id: id,
                    source
                }
            }
            // 直播列表
            if (name === 'liveList') {
                eventType = 'livebroadcastdetails_exhibits_click'
                params = {
                    exhibit_id: id,
                    exhibitor_id: data.actorId,
                    live_state: data.liveState,
                    live_party: data.liveParty,
                    source
                }
            }
            // 直播详情
            if (name === 'liveDetail') {
                eventType = 'liveDetail_exhibits_details_click'
                params = {
                    exhibit_id: id,
                    exhibitor_id: data.exhibitorId || data.actorId,
                    live_id: data.liveId,
                    live_state: data.liveState,
                    source
                }
            }
            // 工作台浏览记录
            if (name === 'footprintList') {
                eventType = 'Browsinghistory_Exhibitsodetails_click'
                params = {
                    exhibit_id: id,
                    exhibitor_id: data.exhibitorId,
                    source
                }
            }
            // 工作台收藏记录
            if (name === 'CollectionList') {
                eventType = 'Collectionrecordpage_Exhibitsodetails_click'
                params = {
                    exhibit_id: id,
                    exhibitor_id: data.exhibitorId,
                    source
                }
            }
            // 工作台右侧广告位
            if (moduleName === 'advertisement_workbench_right') {
                eventType = 'workbenchpage_Advertisingspace_click'
                params = {
                    exhibit_id: id,
                    module_name: moduleName,
                    source
                }
            }
            // 展品预览
            // 在邮件模板中点击进来的
            if (name === 'findExhibitDetail') {
                eventType = 'exhibitdetails_view'
                params = {
                    exhibit_id: id,
                    source
                }
                if (moduleName === 'exhibitDetial') {
                    eventType = 'exhibitsProfile_click'
                } else {
                    if (data.source === 'visitorEmail') {
                        params.external_source = 'visitorEmail'
                    }
                    if (data.userAccountId) {
                        params.external_source = 'actorInvite' 
                    }
                }
            }
            break
        case 'live':
            // 首页
            if (name === 'Home') {
                // 参展商直播
                if (moduleName === 'exhibitor') {
                    eventType = 'homeexhibitor_live_detailsbutton_click'
                    params = {
                        live_id: id,
                        exhibitor_id: data.exhibitorId,
                        live_state: data.liveState,
                        live_party: data.liveParty,
                        source
                    }
                }
                // 同期活动
                if (moduleName === 'conCurrent') {
                    eventType = 'homeHost_live_livedetails_click'
                    params = {
                        live_id: id,
                        exhibitor_id: data.liveSponsorId,
                        live_state: data.liveState,
                        live_party: data.liveParty,
                        source
                    }
                }
            }
            // 直播列表
            if (name === 'liveList') {
                eventType = 'livebroadcastdetails_view'
                params = {
                    live_id: id,
                    exhibitor_id: data.liveSponsorId,
                    live_state: data.liveState,
                    live_party: data.liveParty,
                    source
                }
            }
            // 直播详情页面浏览
            if (name === 'liveDetail') {
                eventType = 'live_view'
                params = {
                    live_id: id,
                    exhibitor_id: data.liveSponsorId,
                    live_state: data.liveState,
                    live_party: data.liveParty,
                    source
                }
            }
            break
        case 'person':
            // 工作台邀约管理
            if (name === 'invite') {
                eventType = 'Invitationpagepage_visitordetails_click'
                params = {
                    visitor_id: id,
                    source
                }
            }
            break
    }
    window.PC.$RangersEvent(eventType, params)
}

// 邀约（展商、展品） 埋点
window.PC.$RangersEventInvite = function(id, exhibitorId, exhibitId, moduleName) {
    let { route } = router.resolve({})
    let name = route.name
    let options = route.params
    let source = name
    let eventType = ''
    let params

    // 列表页面
    if (name === 'findList') {
        if (options.type === 'actor') {
            eventType = 'exhibitsList_inviteBtn_click'
            params = {
                exhibitor_id: exhibitorId,
                employee_id: id,
                source
            }
        } else if (options.type === 'product') {
            eventType = 'exhibitsProfile_inviteBtn_click'
            params = {
                exhibitor_id: exhibitorId,
                exhibit_id: exhibitId,
                employee_id: id,
                source
            }
        }
    }

    // 搜索列表
    if (name === 'searchList') {
        if (!exhibitId) {
            eventType = 'exhibitsList_inviteBtn_click'
            params = {
                exhibitor_id: exhibitorId,
                employee_id: id,
                source
            }
        } else {
            eventType = 'exhibitsProfile_inviteBtn_click'
            params = {
                exhibitor_id: exhibitorId,
                exhibit_id: exhibitId,
                employee_id: id,
                source
            }
        }
    }

    // 展商详情
    if (name === 'findExhibitorDetail') {
        if (exhibitId) {
            // 详情页面展品卡片邀约
            eventType = 'exhibitordetails_inviteBtn_click'
            params = {
                exhibitor_id: exhibitorId,
                exhibit_id: exhibitId,
                employee_id: id,
                source
            }
        } else {
            if (moduleName === 'footer') {
                // 详情页面底部邀约
                eventType = 'exhibitordetails_invite_exhibitorsseemore_click'
                params = {
                    exhibitor_id: exhibitorId,
                    employee_id: id,
                    source
                }
            } else {
                // 详情页面邀约
                eventType = 'exhibitsList_inviteBtn_click'
                params = {
                    exhibitor_id: exhibitorId,
                    employee_id: id,
                    source
                }
            }
        }
    }

    // 展品详情
    if (name === 'findExhibitDetail') {
        eventType = 'exhibitdetails_inviteBtn_click'
        if (moduleName === 'exhibitDetial') {
            eventType = 'exhibitsProfile_inviteBtn_click'
        }
        params = {
            exhibitor_id: exhibitorId,
            exhibit_id: exhibitId,
            employee_id: id,
            source
        }
    }

    // 直播详情
    if (name === 'liveDetail') {
        eventType = 'livebroadcastdetails_inviteBtn_click'
        params = {
            exhibitor_id: exhibitorId,
            exhibit_id: exhibitId,
            employee_id: id,
            source
        }
    }

    // 工作台浏览记录
    if (name === 'footprintList') {
        if (identity === 'VISITOR') {
            if (exhibitId) {
                eventType = 'Browsinghistory_ExhibitsInvitation_click'
                params = {
                    exhibitor_id: exhibitorId,
                    exhibit_id: exhibitId,
                    employee_id: id,
                    source
                }
            } else {
                eventType = 'Browsinghistory_ExhibitorInvitation_click'
                params = {
                    exhibitor_id: exhibitorId,
                    employee_id: id,
                    source
                }
            }
        }
    }

    // 工作台收藏记录
    if (name === 'CollectionList') {
        if (identity === 'VISITOR') {
            if (exhibitId) {
                eventType = 'Collectionrecordpage_ExhibitsInvitation_click'
                params = {
                    exhibitor_id: exhibitorId,
                    exhibit_id: exhibitId,
                    employee_id: id,
                    source
                }
            } else {
                eventType = 'Collectionrecordpage_ExhibitorInvitation_click'
                params = {
                    exhibitor_id: exhibitorId,
                    employee_id: id,
                    source
                }
            }
        }
    }

    window.PC.$RangersEvent(eventType, params)
}

// 收藏埋点（展商，展品，客商）
window.PC.$RangersEventCollect = function(id, data, moduleName) {
    if (data.deleted) return
    let { route } = router.resolve({})
    let name = route.name
    let source = name
    let eventType = ''
    let params
    // 列表页面
    if (name === 'findList' || name === 'searchList') {
        if (data.collectionSubjectType === 'ACTOR') {
            eventType = 'exhibitorsList_favoriteBtn_click'
            params = {
                exhibitor_id: id,
                source
            }
        } else if (data.collectionSubjectType === 'PRODUCT') {
            eventType = 'exhibitsProfile_favoriteBtn_click'
            params = {
                exhibitor_id: data.actorId,
                exhibit_id: id,
                source
            }
        }
    }
    
    // 展商详情
    if (name === 'findExhibitorDetail') {
        if (data.collectionSubjectType === 'ACTOR') {
            eventType = 'exhibitorsList_favoriteBtn_click'
            params = {
                exhibitor_id: id, 
                source
            }

        } else {
            // 展商详情展品卡片收藏
            eventType = 'exhibitordetails_favoriteBtn_click'
            params = {
                exhibitor_id: data.actorId,
                exhibit_id: id,
                source
            }
        }
    }

    // 展品详情
    if (name === 'findExhibitDetail') {
        eventType = 'exhibitdetails_favoriteBtn_click'
        if (moduleName === 'exhibitDetial') {
            eventType = 'exhibitsProfile_favoriteBtn_click'
        }
        params = {
            exhibitor_id: data.actorId,
            exhibit_id: id,
            source
        }
    }

    // 直播详情
    if (name === 'liveDetail') {
        eventType = 'livebroadcastdetails_favoriteBtn_click'
        params = {
            exhibitor_id: data.actorId,
            exhibit_id: id,
            live_id: data.liveId,
            source
        }
    }

    window.PC.$RangersEvent(eventType, params)
}

// 消息 环信IM
window.PC.$RangersEventMsg = function(data) {
    let { route } = router.resolve({})
    let name = route.name
    let source = name
    let eventType = ''
    let params = {}

    // 找展品，展商列表页面
    if (name === 'findList' || name === 'searchList') {
        if (data.exhibitId) {
            eventType = 'exhibitsProfile_imBtn_click'
            params = {
                exhibitor_id: data.exhibitorId,
                exhibit_id: data.exhibitId,
                employee_id: data.id,
                chat_account: data.easemobAccount,
                source
            }
        } else if (data.exhibitorId) {
            eventType = 'exhibitorsList_imBtn_click'
            params = {
                exhibitor_id: data.exhibitorId,
                employee_id: data.id,
                chat_account: data.easemobAccount,
                source
            }
        }
    }

    // 展商详情页面
    if (name === 'findExhibitorDetail') {
        if (data.exhibitId) {
            eventType = 'exhibitordetails_imBtn_click'
            params = {
                exhibitor_id: data.exhibitorId,
                exhibit_id: data.exhibitId,
                employee_id: data.id,
                chat_account: data.easemobAccount,
                source
            }
        } else {
            eventType = 'exhibitorsList_imBtn_click'
            params = {
                exhibitor_id: data.exhibitorId,
                employee_id: data.id,
                chat_account: data.easemobAccount,
                source
            }
        }
    }
    
    // 展品详情
    if (name === 'findExhibitDetail') {
        eventType = 'exhibitdetails_imBtn_click'
        params = {
            exhibitor_id: data.exhibitorId,
            exhibit_id: data.exhibitId,
            employee_id: data.id,
            chat_account: data.easemobAccount,
            source
        }
    }

    // 工作台浏览记录
    if (name === 'footprintList') {
        if (identity === 'VISITOR') {
            if (data.exhibitId) {
                eventType = 'Browsinghistory_ExhibitsIM_click'
                params = {
                    exhibitor_id: data.exhibitorId,
                    exhibit_id: data.exhibitId,
                    employee_id: data.id,
                    chat_account: data.easemobAccount,
                    source
                }
            } else {
                eventType = 'Browsinghistory_ExhibitorIM_click'
                params = {
                    exhibitor_id: data.exhibitorId,
                    employee_id: data.id,
                    chat_account: data.easemobAccount,
                    source
                }
            }
        }
    }

    // 工作台收藏记录
    if (name === 'CollectionList') {
        if (identity === 'VISITOR') {
            if (data.exhibitId) {
                eventType = 'Collectionrecordpage_ExhibitsIM_click'
                params = {
                    exhibitor_id: data.exhibitorId,
                    exhibit_id: data.exhibitId,
                    employee_id: data.id,
                    chat_account: data.easemobAccount,
                    source
                }
            } else {
                eventType = 'Collectionrecordpage_ExhibitorIM_click'
                params = {
                    exhibitor_id: data.exhibitorId,
                    employee_id: data.id,
                    chat_account: data.easemobAccount,
                    source
                }
            }
        }
    }

    // 工作台邀约管理
    if (name === 'invite') {
        if (identity === 'VISITOR') {
            eventType = 'Invitationpagepage_ExhibitorIM_click'
            params = {
                exhibitor_id: data.exhibitorId,
                employee_id: data.id,
                chat_account: data.easemobAccount,
                source
            }
        } else {
            eventType = 'Invitationpagepage_visitorIM_click'
            params = {
                employee_id: data.id,
                chat_account: data.easemobAccount,
                source
            }
        }
    }

    // 工作台意向订单管理
    if (name === 'potentialOrder') {
        if (identity === 'VISITOR') {
            eventType = 'Intentionorderpage_ExhibitorIM_click'
            params = {
                exhibitor_id: data.exhibitorId,
                employee_id: data.id,
                chat_account: data.easemobAccount,
                source
            }
        } else {
            eventType = 'Intentionorderpage_visitorIM_click'
            params = {
                employee_id: data.id,
                chat_account: data.easemobAccount,
                source
            }
        }
    }

    // 工作台意发送消息
    if (name === 'Chat') {
        eventType = 'chat_IM_click'
        if (identity === 'VISITOR') {
            params = {
                exhibitor_id: data.exhibitorId,
                employee_id: data.id,
                chat_account: data.easemobAccount,
                source
            }
        } else {
            params = {
                employee_id: data.id,
                chat_account: data.easemobAccount,
                source
            }
        }
    }

    // 直播详情
    if (name === 'liveDetail') {
        eventType = 'livebroadcastdetails_imBtn_click'
        params = {
            exhibitor_id: data.exhibitorId,
            exhibit_id: data.exhibitId,
            employee_id: data.id,
            chat_account: data.easemobAccount,
            source
        }
    }

    window.PC.$RangersEvent(eventType, params)
}

// 商脉圈统计
window.PC.$RangersEventOpportunity = function(identity, type, data) {
    let eventType = ''
    let params = {}

    if (identity === 'VISITOR') {
        switch(type) {
            case 'view':
                eventType = 'businesscirclelist_view'
                break
            case 'comment':
                eventType = 'businesscirclelist_comment_click'
                params = {
                    exhibitor_id: data.operateSubjectId,
                    businessCircle_id: data.commercialDistrictId
                }
                break
            case 'like':
                eventType = 'businesscirclelist_fabulous_click'
                params = {
                    exhibitor_id: data.operateSubjectId,
                    businessCircle_id: data.commercialDistrictId
                }
                break
        }
    }

    if (type === 'send') {
        // 发送商脉圈
        eventType = 'Releaserequirements_confirm_click'
    }

    window.PC.$RangersEvent(eventType, params)
}

// 直播列表统计 (不区分客商、展商)
window.PC.$RangersEventLive = function(type, data) {
    let eventType = ''
    let params = {
        live_list: data.type
    }

    switch(type) {
        case 'view':
            eventType = 'livelist_view'
            break
        case 'search':
            eventType = 'livelist_screenbutton_click'
            break
    }
    window.PC.$RangersEvent(eventType, params)
}

/**
 * 直播详情统计 (不区分客商、展商)
 * 交换名片
 * 想看
 * 点赞
 * 发现弹幕
 */
window.PC.$RangersEventLiveDetail = function(type, data) {
    let eventType = ''
    let params = {
        live_id: data.id,
        exhibitor_id: data.liveSponsorId,
        live_party: data.liveParty,
        live_state: data.liveState
    }

    switch(type) {
        case 'exchangecards':
            // 交换名片
            eventType = 'livebroadcastdetails_exchangecardsnbutton_click'
            break
        case 'miss':
            // 想看
            eventType = 'livebroadcastdetails_wantseebutton_click'
            break
        case 'like':
            // 点赞
            eventType = 'livebroadcastdetails_fabulous_click'
            break
        case 'sendDanMu':
            // 发现弹幕
            eventType = 'livebroadcastdetails_interactive_news_click'
            break
    }

    window.PC.$RangersEvent(eventType, params)
}

// 不区分客商展商
// 登录注册页面埋点
window.PC.$RangersEventLoginAndRegister = function(type, data, fn) {
    let fromRegister = localStorage.getItem('fromRegister')
    let eventType = ''
    let params = {}
    switch(type) {
        case 'selectidentity':
            // 选择身份页面
            eventType = 'Selectidentitypage_view'
            break
        case 'selectidentity_click':
            // 身份切换
            if (data.status === 'ACTOR') {
                eventType = 'Selectidentitypage_exhibition_click'
            } else {
                eventType = 'Selectidentitypage_visitor_click'
            }
            break
        case 'login_view':
            // 登录页面
            eventType = 'loginPage_view'
            break
        case 'facebook':
            eventType = 'loginPage_facebook_click'
            break
        case 'linkedin':
            eventType = 'loginPage_linying_click'
            break
        case 'google':
            eventType = 'loginPage_google_click'
            break
        case 'register':
            // 邮箱或者手机号注册
            if (data.status) {
                eventType = 'loginPage_registerunder_email_login_click'
            } else {
                eventType = 'loginPage_registerunder_mobile_login_click'
            }
            break
        case 'sendCode':
            // 登录页面验证码
            eventType = 'loginPage_verification_click'
            params = data
            break
        case 'signin':
            // 登录按钮点击
            eventType = 'loginPage_signin_click'
            params = {
                login_type: data.status ? 'email' : 'mobile',
                account: data.account
            }
            if (fromRegister) {
                params.source = fromRegister
            }
            break
        case 'privacy_policy':
            // 隐私条款按钮
            eventType = 'loginPage_privacyPolicy_click'
            break
        case 'language':
            // 切换语言按钮
            eventType = 'loginPage_switchLanguage_click'
            break
        case 'back':
            // 返回按钮
            eventType = 'loginPage_backBtn_click'
            break
        case 'forget_password':
            // 忘记密码
            eventType = 'loginPage_forgetPassword'
            params = {
                login_type: data.status ? 'email' : 'mobile'
            }
            break
        case 'password_view':
            // 密码页面预览
            eventType = 'forgetPasswordPage_view'
            break
        case 'password_ok':
            // 设置密码ok
            eventType = 'findPassword_ok_click'
            params = data
            break
        case 'mobileregistration_view':
            // 手机号注册页面预览
            eventType = 'mobileregistration_view'
            break
        default:
            eventType = type
            params = data
    }

    window.PC.$RangersEvent(eventType, params, fn)
}

// 返回首页
window.PC.$RangersEventHomeBack = function() {
    let { route } = router.resolve({})
    let name = route.name
    let eventType = ''

    // 邮箱注册
    if (name === 'registerEmail') {
        if (route.params.id == 1) {
            eventType = 'Emailaccountcreation_backtohome_click'
        }
    }
    // 手机号注册
    if (name === 'registerMobile') {
        if (route.params.id == '0') {
            eventType = 'mobileregistration_backtohome_click'
        }
    }

    // 邮箱设置密码页
    if (name === 'registerPassWord') {
        eventType = 'Emailpasswordpage_backtohome_click'
    }

    // 预登记完成页面
    if (name === 'registerCompleted') {
        eventType = 'Registrationcompletedpage_Enterthehomepage_click'
    }

    window.PC.$RangersEventLoginAndRegister(eventType)
}

// 在线客服
window.PC.$RangersEventOnlineService = function() {
    let { route } = router.resolve({})
    let name = route.name
    let eventType = ''

    // 邮箱注册
    if (name === 'registerEmail') {
        if (route.params.id == 1) {
            eventType = 'Emailaccountcreation_OnlineService_click'
        }
        if (route.params.id == 2) {
            eventType = 'Emailconfirmationpage_OnlineService_click'
        }
    }
    // 手机号注册
    if (name === 'registerMobile') {
        if (route.params.id == '0') {
            eventType = 'mobileregistration_OnlineService_click'
        }
    }

    if (name === 'Home') {
        eventType = 'Homepagesuspension_OnlineService_Click'
    } 

    window.PC.$RangersEventLoginAndRegister(eventType)
}

// 问卷页面
window.PC.$RangersEventQuestion = function(type) {
    let { route } = router.resolve({})
    let name = route.name
    let fromRegister = localStorage.getItem('fromRegister')
    let params = {}

    // 注册流程
    if (name === 'questionnaire') {
        if (type === 'questionPage_Submit_click' && fromRegister) {
            localStorage.removeItem('fromRegister')
            params.source = fromRegister
        }
        window.PC.$RangersEvent(type)
    }
}

// 预登记页面埋点
window.PC.$RangersEventPreRegistration = function(type, data={}) {
    let fromRegister = localStorage.getItem('fromRegister')
    let { route } = router.resolve({})
    let name = route.name
    let eventType = ''
    let params = data
    
    if (name === 'lAccountInfoEmail' || name === 'lAccountInfoMobile') {
        // 第一步预登记
        switch(type) {
            case 'view':
                eventType = 'firstInfo_view'
                break
            case 'saveBtn':
                eventType = 'firstInfo_saveBtn_click'
                if (fromRegister) {
                    params.source = fromRegister
                }
                break
            case 'backBtn':
                eventType = 'firstInfo_backBtn_click'
                break    
        }
    } else if (name === 'account-info') {
        // 第二步预登记
        switch(type) {
            case 'view':
                eventType = 'secondInfo_view'
                break
            case 'saveBtn':
                eventType = 'secondInfo_saveBtn_click'
                if (fromRegister) {
                    params.source = fromRegister
                }
                break
            case 'backBtn':
                eventType = 'secondInfo_backBtn_click'
                break   
        }
    }

    window.PC.$RangersEvent(eventType, params)
}

// 工作台页面埋点
window.PC.$RangersEventWorkbench = function(type, data) {
    // let { route } = router.resolve({})
    // let name = route.name
    let eventType = ''
    let params = {}

    switch(type) {
        case 'invite_sure':
            // 邀约管理 确认
            if (identity === 'ACTOR') {
                eventType = 'Invitationpagepage_confirmbutton_click'
            } else {
                eventType = 'Invitationpagepage_VISITOR_confirmbutton_click'
            }
            break
        case 'Intentionorderpage_tagging_click':
            // 意向订单 状态改变（未联系/已联系）
            eventType = type
            params = {
                status: data.status
            }
            break
        default:
            eventType = type
    }
    window.PC.$RangersEvent(eventType, params)
}